import createRoute       from '@widesk-ui/tools/createRoute';
import CancelReasonModel from '@models/shop/CancelReasonModel';

export default createRoute.table('/cancel_reasons', 'shop', 'CancelReasonTable', CancelReasonModel.localize('plural'));